import { Icon } from ".."
import { formatTimeString, getTimeDateString } from "../../../utils/date"

const TimeFormat = ({ color = "", date, isTimeOnlyStr, className, icon = "BiTimeFive" }) => {
  const formattedDate = isTimeOnlyStr ? formatTimeString(date) : getTimeDateString(date, true, false, true)
  return (
    formattedDate && (
      <div className={className}>
        <Icon icon={icon} size="14px" />
        &nbsp; <span style={{ color: color }}>{formattedDate}</span>
      </div>
    )
  )
}

export default TimeFormat
